<template>
  <v-row>
    <v-col>
      <v-col class="d-flex justify-space-between mx-auto flex-wrap container">
        <v-btn-toggle
          group
          tile
          color="indigo lighten-2 accent-3"
          v-model="buttonSelected"
          class="flex-wrap"
        >
          <v-btn @click="showHolidayGroup">{{
            $tc("modelsLiquidations.modelsLiquidations")
          }}</v-btn>
          <v-btn @click="showHolidays">{{
            $tc("rulesDistribution.ruleDistribution")
          }}</v-btn>
        </v-btn-toggle>
        <ToolbarTitles />
        <ButtonsCardList @cardView="cardView" />
      </v-col>
      <div v-if="buttonSelected === 0" class="container">
        <ModelsLiquidations :showCard="showCard" />
      </div>
      <div v-else-if="buttonSelected === 1" class="container">
        <SettlementRules :showCard="showCard" />
      </div>
    </v-col>
  </v-row>
</template>

<script>
import ToolbarTitles from "@/components/Complement/ToolbarTitles.vue";
import ButtonsCardList from "@/components/Complement/ButtonsCardList.vue";
import ModelsLiquidations from "./ModelosDeLiquidacion/ModelsLiquidations.vue";
import Loader from "@/components/Complement/Loader.vue";
import SettlementRules from "./ReglasDeLiquidacion/SettlementRules.vue";
import holidaysGroups from "@/store/gruposDeFeriados/holidaysGroups";
export default {
  components: {
    SettlementRules,
    ModelsLiquidations,
    Loader,
    ToolbarTitles,
    ButtonsCardList,
  },
  data() {
    return {
      buttonSelected: 0,
      isLoading: true,
      showCard: true,
    };
  },
  computed: {
    padding() {
      return holidaysGroups.state.paddingNav;
    },
  },
  methods: {
    cardView(value) {
      this.showCard = value;
    },
    showHolidayGroup() {
      this.isLoading = true;
      this.$nextTick(() => {
        this.buttonSelected = 0;
        this.isLoading = false;
      });
    },
    showHolidays() {
      this.isLoading = true;
      this.$nextTick(() => {
        this.buttonSelected = 1;
        this.isLoading = false;
      });
    },
  },
};
</script>
<style>
.container {
  max-width: 100%;
  padding-top: 1vh;
  padding-bottom: 1vh;
}
</style>
